export const loaiPhieuThanhToanEndpoint = `${
  process.env.REACT_APP_ENDPOINT_URL
}/loai-phieu-thanh-toan`;

export const LOAI_PHIEU_THANH_TOAN_PREFIX_URL = "/loai-phieu-thanh-toan";
